import { useEffect, useState } from "react";
import { groupCompaniesForSpreadsheet } from "../../helper/spreadsheetView";

/**
 * Selection spans pages of one query, but the grid only holds the visible page. Keep the
 * selected companies here so paid actions and their confirmation cover all of them.
 * Deriving from `selectedIds` means every selection reset (query change, saved-search
 * hydration, post-export clear) drops the retained companies too.
 */
export default function useSelectedCompanies(companies, selectedIds) {
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  useEffect(() => {
    setSelectedCompanies((previous) => {
      const byId = new Map([...previous, ...groupCompaniesForSpreadsheet(companies)]
        .map((company) => [company.stagedId, company]));
      return Array.from(selectedIds, (id) => byId.get(id)).filter(Boolean);
    });
  }, [companies, selectedIds]);
  return selectedCompanies;
}
